module.exports = __webpack_public_path__ + "img/cloud.e0599065.png";